import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";

import moment from "moment";
import SightSeeingTabs from "../AllTabs/SightSeeingTabs";
const SightSeeingBookings = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const GetData = async (pageNumber) => {
    setPageLoading(true);
    const res = await apiService.post(
      `${config.GETPARENTCOMPANYSIGHTSEEINGBOOKINGS}/${user?.cid}`,
      pageSize,
      pageNumber
    );
    console.log(res);
    setLists(res);
    setPageLoading(false);
  };
  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <SightSeeingTabs pageName="SIGHTSEEINGBOOKING" />
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="sightseeingTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Booking No</th>
                          <th>Destination</th>
                          <th>Travel Date</th>
                          <th>Traveller</th>
                          <th>Booking Status</th>
                          <th>Payment Status</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      {pageLoading ? (
                        <tbody>
                          <tr>
                            <td colSpan="9" className="text-center">
                              <img
                                src="/assets/images/loader.webp"
                                width="64px"
                                height="64px"
                                alt="Loading..."
                              />
                              <p>Loading, Please wait...</p>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.sightSeeingBookingId}>
                                <td>{index + 1}</td>
                                <td>{v.bookingNo}</td>
                                <td>{v.city}</td>
                                <td>{moment(v.travelDate).format("DD MMM YYYY")}</td>
                                <td>{v.travellerName}</td>
                                <td>
                                  <span className={`badge bg-${v.bookingStatus === 'CONFIRMED' ? 'success' : 'warning'}`}>
                                    {v.bookingStatus}
                                  </span>
                                </td>
                                <td>
                                  <span className={`badge bg-${v.paymentStatus === 'SUCCESS' ? 'success' : 'danger'}`}>
                                    {v.paymentStatus}
                                  </span>
                                </td>
                                <td>{Math.round(v.customerPrice)} INR</td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li className="list-inline-item">
                                      <Link
                                        to={`/sightseeing/booking/${v.sightSeeingBookingId}`}
                                        className="btn btn-sm btn-primary"
                                      >
                                        VIEW
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center">No bookings found.</td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SightSeeingBookings;